import { useXmppListener, useQuery, useApi, useCoreConfig } from '#imports'

export const useGameCombinedJackpot = (options?: { lazy: boolean, enabled: boolean }) => {
    const api = useApi({ enableLegacySupport: true, service: 'monolith' })

    const { site } = useCoreConfig()

    const { lazy = true, enabled = true } = options ?? {}

    const query = useQuery(async () => {
        const response = await api<{ amount: number } | undefined>('/jackpots/combined_jackpot', {
            query: {
                brand: site.brand
            }
        })

        return response?.amount
    }, { key: 'game:combinedJackpot', lazy, server: !lazy, enabled })

    if (import.meta.client) {
        // Set listener to update Combined Jackpot via websocket
        useXmppListener<{ amount: number } | undefined>({ kind: 'message', xmlns: 'cego:CombinedJackpotUpdated' }, (result) => {
            if (!result) return
            query.data.value = result.amount
        })
    }

    return query.enrich({
        combinedJackpot: query.data,
    })
}
